export default function NotFound() {
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center p-6 text-center">
      <div className="text-6xl font-bold text-brand">404</div>
      <p className="mt-2 text-brand-ink/70">This page does not exist.</p>
      <a href="/" className="btn-primary mt-6">Home</a>
    </main>
  );
}
